import React from 'react';

const permissionContext = React.createContext({
    permissions: []
}); // Create a context object

export {
    permissionContext // Export it so it can be used by other Components
};